export default "__VITE_ASSET__8a8dcb5a__"